<template>
  <div>
    <PurchaseOrdersFilters />
    <TolAlert v-if="tolAlert" v-bind="tolAlert" />
    <PurchaseOrderActions @load-spinner="loadSpinner($event)" />
    <tol-table
      :table-data="purchaseOrders"
      :columns="columns"
      :is-row-clickable="true"
      @row-click="handleRowClick($event)"
    >
      <template v-slot:tableHeader>
        <th-sortable
          :direction="currentSortField === 'purchase_order_number' ? currentSortDirection : 'none'"
          field-name="purchase_order_number"
          @change="onSortOrderChange"
          >{{ $t('purchaseOrders.listing.labels.purchase_order_number') }}
        </th-sortable>
        <th-sortable
          :direction="currentSortField === 'client_name' ? currentSortDirection : 'none'"
          field-name="client_name"
          @change="onSortOrderChange"
          >{{ $t('purchaseOrders.listing.labels.client_name') }}
        </th-sortable>
        <th-sortable
          :direction="currentSortField === 'end_client_name' ? currentSortDirection : 'none'"
          field-name="end_client_name"
          @change="onSortOrderChange"
          >{{ $t('purchaseOrders.listing.labels.end_client_name') }}
        </th-sortable>
        <th-sortable
          :direction="currentSortField === 'status' ? currentSortDirection : 'none'"
          field-name="status"
          @change="onSortOrderChange"
          >{{ $t('purchaseOrders.listing.labels.status') }}
        </th-sortable>
        <th-sortable
          :direction="currentSortField === 'start_date' ? currentSortDirection : 'none'"
          field-name="start_date"
          @change="onSortOrderChange"
          >{{ $t('purchaseOrders.listing.labels.start_date') }}
        </th-sortable>
        <th-sortable
          :direction="currentSortField === 'end_date' ? currentSortDirection : 'none'"
          field-name="end_date"
          @change="onSortOrderChange"
          >{{ $t('purchaseOrders.listing.labels.end_date') }}
        </th-sortable>
        <th-sortable
          :direction="currentSortField === 'funds_issued' ? currentSortDirection : 'none'"
          field-name="funds_issued"
          @change="onSortOrderChange"
          >{{ $t('purchaseOrders.listing.labels.funds_issued') }}
        </th-sortable>
        <th>{{ $t('purchaseOrders.listing.labels.funds_remaining') }}</th>
        <th>{{ $t('purchaseOrders.listing.labels.percentage_remaining') }}</th>
      </template>
      <template v-slot:reference_number="{ value }">
        <router-link :to="value.reference_number">{{ value.reference_number }}</router-link>
      </template>
      <template v-slot:start_date="{ value }">
        <font-awesome-icon icon="calendar-alt" />
        {{ formatDate(value.start_date) }}
      </template>
      <template v-slot:end_date="{ value }">
        <font-awesome-icon icon="calendar-alt" />
        {{ formatDate(value.end_date) }}
      </template>
      <template v-slot:funds_issued="{ value }">
        {{ formatAmount(value.funds_issued) }}
      </template>
      <template v-slot:funds_remaining="{ value }">
        {{ formatAmount(value.funds_remaining) }}
      </template>
      <template v-slot:percentage_remaining="{ value }">
        <div :class="percentClass(value.percentage_remaining)">
          {{ value.percentage_remaining != null ? value.percentage_remaining + '%' : '-' }}
        </div>
      </template>
    </tol-table>
    <Pagination
      :records-per-page="listPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>
<script>
import TolTable from '../../../../components/TolTable';
import TolAlert from '../../../../components/TolAlert';
import ThSortable from '../../../../components/ThSortable';
import Pagination from '../../../../components/Pagination';
import PurchaseOrdersFilters from '../purchase-orders-listing/components/PurchaseOrdersFilters';
import PurchaseOrderActions from '../purchase-orders-listing/components/PurchaseOrdersActions';
import {
  PurchaseOrdersListingGetters,
  PurchaseOrdersListingActions
} from './purchase-orders-listing.keys';
import { currencyUtils } from '@/mixins/currency-utils';
import format from 'date-fns/format';
export default {
  name: 'PurchaseOrdersListing',
  components: {
    TolTable,
    ThSortable,
    Pagination,
    PurchaseOrdersFilters,
    PurchaseOrderActions,
    TolAlert
  },
  mixins: [currencyUtils],
  computed: {
    purchaseOrders() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrders];
    },
    columns() {
      return [
        'purchase_order_number',
        'client_name',
        'end_client_name',
        'status',
        'start_date',
        'end_date',
        'funds_issued',
        'funds_remaining',
        'percentage_remaining'
      ];
    },
    currentSortField() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrdersSortBy];
    },
    currentSortDirection() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrdersSortDirection];
    },
    listPerPage() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrdersPerPage];
    },
    currentPage() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrdersListingOffset];
    },
    recordCount() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrdersCount];
    },
    tolAlert() {
      return false;
    }
  },
  mounted() {
    this.$store.dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrders);
    this.$store.dispatch(PurchaseOrdersListingActions.RetrievePurchaseOrdersCount);
  },
  methods: {
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(PurchaseOrdersListingActions.SetPurchaseOrdersSortOrder, sortOrder);
    },
    onChangePaginationParams(evt) {
      this.$store.dispatch(PurchaseOrdersListingActions.SetPurchaseOrdersPaginationParameters, evt);
    },
    formatDate(d) {
      return d ? format(d, 'YYYY-MM-DD') : null;
    },
    formatAmount(amount) {
      return this.formatCurrency(amount || 0);
    },
    percentClass(percentage_remaining) {
      let className = '';
      if (percentage_remaining > 25) {
        className = 'green';
      } else if (percentage_remaining < 25 && percentage_remaining > 20) {
        className = 'yellow';
      } else {
        className = 'red';
      }

      return className;
    },
    loadSpinner(flag) {
      this.$store.dispatch(PurchaseOrdersListingActions.SetPurchaseOrdersLoading, flag);
    },
    handleRowClick(evt) {
      this.$router.push(`/purchase-orders/${evt.reference_number}`);
    }
  }
};
</script>

<style lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.red {
  color: $white;
  font-weight: bold;
  width: 100%;
  height: 100%;
  background-color: $mid-red;
  display: flex;
  align-items: center;
  justify-content: center;
}
.green {
  color: $white;
  font-weight: bold;
  width: 100%;
  height: 100%;
  background-color: $secondary-green;
  display: flex;
  align-items: center;
  justify-content: center;
}
.yellow {
  color: $white;
  font-weight: bold;
  width: 100%;
  height: 100%;
  background-color: $primary-warn;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
